var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30255 2H3.70109C2.76311 2 2 2.76311 2 3.70109V9.30255C2 10.2405 2.76311 11.0036 3.70109 11.0036H9.30255C10.2405 11.0036 11.0036 10.2405 11.0036 9.30255V3.70109C11.0036 2.76311 10.2405 2 9.30255 2Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2989 2H14.6974C13.7594 2 12.9963 2.76311 12.9963 3.70109V9.30255C12.9963 10.2405 13.7594 11.0036 14.6974 11.0036H20.2989C21.2369 11.0036 22 10.2405 22 9.30255V3.70109C22 2.76311 21.2369 2 20.2989 2Z",
    fill: "#959595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30255 12.9965H3.70109C2.76311 12.9965 2 13.7596 2 14.6976V20.299C2 21.237 2.76311 22.0001 3.70109 22.0001H9.30255C10.2405 22.0001 11.0036 21.237 11.0036 20.299V14.6976C11.0036 13.7596 10.2405 12.9965 9.30255 12.9965Z",
    fill: "#959595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2989 12.9965H14.6975C13.7595 12.9965 12.9964 13.7596 12.9964 14.6976V20.299C12.9964 21.237 13.7595 22.0001 14.6975 22.0001H20.2989C21.2369 22.0001 22 21.237 22 20.299V14.6976C22 13.7596 21.2369 12.9965 20.2989 12.9965Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewIcon);
export default __webpack_public_path__ + "static/media/grid-view-icon.458e5758ffb07e75ede8fa7e51bceb78.svg";
export { ForwardRef as ReactComponent };